import React, { FC, CSSProperties } from "react";
import { BoxWrapper } from "../Wrappers/Wrappers";
import { Text } from "../units/Text";

export interface TableProps {
    children: React.ReactNode;
    style?: CSSProperties;
    className?: string;
    onClick?: (event: any) => void;
    onMouseMove?: (event: any) => void;
}


export const Table: FC<TableProps> = ({ children, style, className='', ...props }):JSX.Element => {
    return (
        <table className={className} style={style}>
            { children }
        </table>
    )
}


export const Head: FC<TableProps> = ({ children, style, className='', ...props }):JSX.Element => {
    return (
        <thead className={className} style={style}>
            { children }
        </thead>
    )
}


export const Body: FC<TableProps> = ({ children, style, className='', ...props }):JSX.Element => {
    return (
        <tbody className={className} style={style} {...props}>
            { children }
        </tbody>
    )
}


export const Row: FC<TableProps> = ({ children, style, className='', ...props }):JSX.Element => {
    return (
        <tr className={className} style={style} {...props}> 
            { children }
        </tr>
    )
}


export const Th: FC<TableProps> = ({ children, style, className='', ...props }):JSX.Element => {
    return (
        <th className={className} style={style}>
            { children }
        </th>
    )
}


export const Td: FC<TableProps> = ({ children, style, className='', ...props }):JSX.Element => {
    return (
        <td className={className} style={style}>
            { children }
        </td>
    )
}


interface PaginatorButtonProps {
    selected: boolean;
    children: React.ReactNode;
    onClick: React.MouseEventHandler<HTMLHeadingElement>;
}


export const PaginatorButton: FC<PaginatorButtonProps> = ({ children, selected=false, onClick, ...props }):JSX.Element => {
    return (
        <span
            className={`p05 r5 pointer ${selected ? 'bg-secondary text-light' : 'bg-transparent'}`} 
            style={{minWidth:"15px", textAlign:"center"}}
            onClick={onClick}
            {...props}
            >
            { children }
        </span >
    )
}


interface PaginatorProps {
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    style?: CSSProperties;
    className?: string;
    setPage: (value: number) => void;
}


export const Paginator: FC<PaginatorProps> = ({ itemsPerPage, totalItems, currentPage, style, className='', setPage, ...props }):JSX.Element => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const pagination_range = 2;
    return (
        <BoxWrapper className="flex narrow-gap paginator">
            { currentPage-(pagination_range) > 1 &&
                <PaginatorButton key={0} selected={currentPage===1} onClick={() => { setPage(1) }}>
                    1
                </PaginatorButton>
            }
            {
                currentPage-(pagination_range) > 2 && <span>...</span>
            }

            { Array.from({ length: totalPages }, (_:any, index:number) => {
                const page = index + 1
                
                if (page >= currentPage - pagination_range && page <= currentPage + pagination_range) {
                    return (
                        <PaginatorButton key={page} selected={index+1===currentPage} onClick={() => {setPage(index + 1)}}>
                            { page }
                        </PaginatorButton>
                    )
                }
            }) }
            {
                currentPage + (pagination_range) < (totalPages) - 1 && <span>...</span>
            }
            { currentPage + (pagination_range) < (totalPages)  && 
                <PaginatorButton key={totalPages} selected={currentPage===totalPages} onClick={ () => { setPage(totalPages ) } }>
                    {totalPages}
                </PaginatorButton>}

        </BoxWrapper>
    )
}

interface orderControllerProps {
    order?: string;
    value: string;
    setter: (value: string) => void;
}


export const OrderController = ({order, value, setter}: orderControllerProps) => {
    const arrowClassName = "cursor-pointer hover-bright"
    return (
        <div className="flex flex-column xs-gap text-sm">
            <div onClick={ () => { setter(value) } } className={order === value ? arrowClassName + ' text-light' : arrowClassName + ' text-dark'}>▲</div>
            <div onClick={ () => { setter(`-${value}`) } } className={order === `-${value}` ? arrowClassName + ' text-light' : arrowClassName + ' text-dark'}>▼</div>
        </div>
    )
}


export const NoDataComponent = ():JSX.Element => {
    return (
        <BoxWrapper className="flex narrow-gap paginator bg-primary flex justify-center align-center" style={{height: "150px"}}>
            <Text>Ничего не найдено, попробуйте другой запрос.</Text>
        </BoxWrapper>
    )
}  